export default __webpack_public_path__ + "static/media/service7.547b723f.jpeg";